import { Query } from '../../../hooks/queries'
import { AvailableAgent } from '..'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import {
  AgentAvailability,
  getAvailableAgents
} from './requests/get-available-agents-request'

type UseAvailableAgents = (props: {
  organizationUuid: string
  enabled: boolean
}) => UseAvailableAgentsResponse

export interface UseAvailableAgentsResponse {
  isLoading: boolean
  isError: boolean
  enabledAgentTypes: string[]
  availableAgents: AvailableAgent[]
  refetch: () => Promise<void>
}

export const useAvailableAgents: UseAvailableAgents = ({
  organizationUuid,
  enabled
}) => {
  const { data, isLoading, isError, refetch } = useContrastQuery(
    [Query.AVAILABLE_AGENTS, organizationUuid],
    getAvailableAgents,
    {
      organizationUuid
    },
    {
      enabled
    }
  )

  return {
    isLoading,
    isError,
    refetch: async () => {
      await refetch()
    },
    enabledAgentTypes:
      !!data && Array.isArray(data.enabledAgentTypes)
        ? data.enabledAgentTypes
        : [],
    availableAgents:
      !!data && !!data.availability ? mapAvailableAgents(data.availability) : []
  }
}

const mapAvailableAgents = (availability: AgentAvailability[]) =>
  availability.map(({ type, name, version, enabled }) => ({
    type: type as AvailableAgent['type'],
    name,
    version,
    enabled
  }))
